import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReportList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/fafsa', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
